<template>
  <v-card
    flat
    class="pa-3 mt-1"
  >
    <v-card-title class="d-flex align-center justify-center py-0">
      <div
        class="d-flex align-center"
      >
        <v-img
          :src="require(`@/assets/images/logos/logo.png`)"
          max-width="300px"
          alt="logo"
          contain
          class="me-0 "
        ></v-img>
      </div>
    </v-card-title>
    <v-form class="multi-col-validation">
      <v-card-text class="pt-1">
        <p class="text-h6 text-center">Add a Bill</p>
        <v-row>
          <v-col cols="10" class="py-0 my-1">
            <v-text-field
              v-model="userName"
              ref="userName"
              outlined dense
              label="Search Payer..."
            ></v-text-field>
          </v-col>
          <v-col cols="2" class="py-0 my-1">
            <v-btn
              color="success"
              class="me-3"
              fab small
              @click="getPayer()"
            >
              <font-awesome-icon icon="fa-solid fa-magnifying-glass" />
            </v-btn>
          </v-col>
          <v-col
            cols="12"
            class="py-0 my-1"
          >
            <v-select
              v-model="selectedClient"
              ref="selectedClient"
              :items="clients"
              item-text="username"
              item-value="id"
              outlined dense
              label="Select Payer"
            ></v-select>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-text-field
              v-model="subject"
              ref="subject"
              outlined dense
              label="Bill Title..."
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-textarea
              outlined
              v-model="description"
              ref="description"
              name="input-7-4"
              label="Enter Bill Description"
            ></v-textarea>
          </v-col>

          <v-col
            cols="12"
            class="py-0 my-1"
          >
            <v-text-field
              v-model="amount"
              ref="amount"
              outlined
              dense
              label="Enter Amount Paid"
            ></v-text-field>
          </v-col>

          <v-col
            cols="12"
            class="py-0 my-1"
          >
            <v-text-field
              v-model="remaining_payment"
              ref="remaining_payment"
              outlined
              dense
              label="Enter Remaining Amount"
            ></v-text-field>
          </v-col>

          <v-col cols="12" class="py-0 my-1">
            <v-file-input
              show-size
              v-model="bill_file"
              ref="bill_file"
              truncate-length="18"
              style="cursor: pointer"
              label="Choose Bill Receipt"
            ></v-file-input>
          </v-col>
        </v-row>
      </v-card-text>

      <v-card-text class="text-end">
        <spinner v-if="loading" class="text-end"></spinner>
        <v-btn 
          v-else
          color="primary"
          class="me-3 mt-3"
          @click="addBill()"
        >
          Add Bill
        </v-btn>
      </v-card-text>
    </v-form>
  </v-card>
</template>

<script>
// eslint-disable-next-line object-curly-newline
import { mdiKeyOutline, mdiLockOpenOutline, mdiEyeOffOutline, mdiEyeOutline } from '@mdi/js'
import axios from 'axios'
import Spinner from "@/components/Spinner.vue";

export default {
  components: {
    Spinner,
  },

  data() {

    return {
      loading: false,
      userName: '',
      clients: [],
      selectedClient: "",

      subject: "",
      description: "",
      bill_file: [],
      amount: "",
      remaining_payment: "",

      mdiKeyOutline,
      mdiLockOpenOutline,
      mdiEyeOffOutline,
      mdiEyeOutline,
    }
  },
  
  mounted(){
      // executes these after the page has been mounted
      document.title = "Manager: Savings | Add Bills"
  },

  methods:{
    getPayer(){
      axios
        .get('/api/v1/manager/get/clients/'+this.userName+'/')
        .then(response => {
          this.clients = response.data  // get the data and fill into campaigns
          this.selectedClient = response.data[0]["id"]  // get the data and fill into campaigns
        })
        .catch(error => {
          if (error.response){
            this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }else{
            this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
            this.$store.commit('setSnackBarColor', "red darken-4")
            this.$store.commit('activateSnackBar', true)
          }
        })
    },

    async addBill(){
      // console.log(this.resourceFile)
      if(this.subject === ""){
          this.$store.commit('setSnackBarMessage', "Please fill in the Bill Title")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.subject.focus()  // this causes a an auto fucos to the element
      }
      else if(this.description === ""){
          this.$store.commit('setSnackBarMessage', "Please input the Bill description")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.description.focus()  // this causes a an auto fucos to the element
      }
      else if(this.amount === ""){
          this.$store.commit('setSnackBarMessage', "Please input the bill amount paid")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.amount.focus()  // this causes a an auto fucos to the element
      }
      else if(this.remaining_payment === ""){
          this.$store.commit('setSnackBarMessage', "Please input the bill amount remaining")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.remaining_payment.focus()  // this causes a an auto fucos to the element
      }
      else if(this.selectedClient === ""){
          this.$store.commit('setSnackBarMessage', "Please select the partner")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.selectedClient.focus()  // this causes a an auto fucos to the element
      }
      else if(!this.bill_file){
          this.$store.commit('setSnackBarMessage', "Please upload the bill receipt")
          this.$store.commit('setSnackBarColor', "red darken-4")
          this.$store.commit('activateSnackBar', true)
          this.$refs.bill_file.focus()  // this causes a an auto fucos to the element
      }
      else {
          this.loading = true

          let formData = new FormData()
          formData.append('payer', this.selectedClient)
          formData.append('subject', this.subject)
          formData.append('description', this.description)
          formData.append('amount_paid', this.amount)
          formData.append('remaining_payment', this.remaining_payment)
          formData.append('bill_file', this.bill_file)

          await axios
              .post('/api/v1/manager/add/bill/', formData, {headers: {'Content-Type': 'multipart/form-data'}})
              .then(response => {
                  this.$store.commit('setSnackBarMessage', response.data[0].text)
                  this.$store.commit('setSnackBarColor', response.data[0].color)
                  this.$store.commit('activateSnackBar', true)
                  if(response.data[0].id !== 0){
                      let router = this.$router
                      setTimeout(function(){
                          router.push({ name: 'savings.bills'})
                      }, 4000)
                  }
              })
              .catch(error => {
                  if (error.response){
                      this.$store.commit('setSnackBarMessage', error.response.status + " " + error.response.statusText)
                      this.$store.commit('setSnackBarColor', "red darken-4")
                      this.$store.commit('activateSnackBar', true)
                  }else{
                      this.$store.commit('setSnackBarMessage', "An error occured, please check your internet connection and try again later.")
                      this.$store.commit('setSnackBarColor', "red darken-4")
                      this.$store.commit('activateSnackBar', true)
                  }
              })

          this.loading = false
      }
    },
  },
}
</script>
